const listenToPreferenceCenterUnsubscribeAllChange = require("./listenToPreferenceCenterUnsubscribeAllChange");
const listenToPreferenceCenterSubscribeAllChange = require("./listenToPreferenceCenterSubscribeAllChange");
const listenToPreferenceCenterFormSubmit = require("./listenToPreferenceCenterFormSubmit");
const uncheckAllPreferenceCenterOptions = require("./uncheckAllPreferenceCenterOptions");
const checkAllPreferenceCenterOptions = require("./checkAllPreferenceCenterOptions");
const listenToAnyPreferenceCenterOptionChange = require("./listenToAnyPreferenceCenterOptionChange");
const uncheckPreferenceCenterSubscribeAll = require("./uncheckPreferenceCenterSubscribeAll");
const uncheckPreferenceCenterUnsubscribeAll = require("./uncheckPreferenceCenterUnsubscribeAll");
const setPreferenceCenterOptionsFromBrowserUrl = require("./setPreferenceCenterOptionsFromBrowserUrl");
const hidePreferenceCenterPhoneNumberField = require("./hidePreferenceCenterPhoneNumberField");
const showPreferenceCenterPhoneNumberField = require("./showPreferenceCenterPhoneNumberField");
const listenToPreferenceCenterSmsSwitchChange = require("./listenToPreferenceCenterSmsSwitchChange");
const whenPreferenceCenterFormSubmit = require("./whenPreferenceCenterFormSubmit");
const getPreferenceCenterCountrySelect = require("./getPreferenceCenterCountrySelect");
const initializeCountryOptionsWithMarketoOptions = require("../countrySelect/initializeCountryOptionsWithMarketoOptions");
const whenPreferenceCenterCountrySelectChange = require("./whenPreferenceCenterCountrySelectChange");
const updateSmsAvailability = require("./updateSmsAvailability");
const getPreferenceCenterFormEmailInput = require("./getPreferenceCenterFormEmailInput");
const hidePreferenceCenterFormEmailError = require("./hidePreferenceCenterFormEmailError");
const getPreferenceCenterPhoneNumberInput = require("./getPreferenceCenterPhoneNumberInput");
const hidePreferenceCenterFormPhoneNumberError = require("./hidePreferenceCenterFormPhoneNumberError");
const appendPreferenceCenterPhoneNumberFormatMessage = require("./appendPreferenceCenterPhoneNumberFormatMessage");
const PreferenceCenter_refreshPrivacyPolicy = require("./PreferenceCenter_refreshPrivacyPolicy");
const PreferenceCenter_getSelectedCountryOption = require("./PreferenceCenter_getSelectedCountryOption");
const PreferenceCenter_getPrivacyPolicyCheckbox = require("./PreferenceCenter_getPrivacyPolicyCheckbox");
const PreferenceCenter_hidePrivacyPolicyError = require("./PreferenceCenter_hidePrivacyPolicyError");

/**
 * @param preferenceCenter {HTMLElement}
 * @return {void}
 */
module.exports = async function PreferenceCenter_init(preferenceCenter) {
    hidePreferenceCenterPhoneNumberField(preferenceCenter);

    setPreferenceCenterOptionsFromBrowserUrl(preferenceCenter);

    listenToPreferenceCenterUnsubscribeAllChange(preferenceCenter, (checked) => {
        if (checked) {
            uncheckAllPreferenceCenterOptions(preferenceCenter);
            hidePreferenceCenterPhoneNumberField(preferenceCenter);
        }

        PreferenceCenter_refreshPrivacyPolicy(preferenceCenter);
    });

    listenToPreferenceCenterSubscribeAllChange(preferenceCenter, (checked) => {
        if (checked) {
            checkAllPreferenceCenterOptions(preferenceCenter);

            const country = PreferenceCenter_getSelectedCountryOption(preferenceCenter);
            if (country === "United States") {
                showPreferenceCenterPhoneNumberField(preferenceCenter);
            }
        }

        PreferenceCenter_refreshPrivacyPolicy(preferenceCenter);
    });

    listenToAnyPreferenceCenterOptionChange(preferenceCenter, () => {
        uncheckPreferenceCenterSubscribeAll(preferenceCenter);
        uncheckPreferenceCenterUnsubscribeAll(preferenceCenter);

        PreferenceCenter_refreshPrivacyPolicy(preferenceCenter);
    });

    listenToPreferenceCenterFormSubmit(preferenceCenter, form => whenPreferenceCenterFormSubmit(form));

    listenToPreferenceCenterSmsSwitchChange(preferenceCenter, (checked) => {
        if (checked) {
            showPreferenceCenterPhoneNumberField(preferenceCenter);
        } else {
            hidePreferenceCenterPhoneNumberField(preferenceCenter);
        }
    });

    const emailInput = getPreferenceCenterFormEmailInput(preferenceCenter);
    emailInput.addEventListener("input", () => {
        hidePreferenceCenterFormEmailError(preferenceCenter);
    });

    const phoneNumberInput = getPreferenceCenterPhoneNumberInput(preferenceCenter);
    phoneNumberInput.addEventListener("input", () => {
        hidePreferenceCenterFormPhoneNumberError(preferenceCenter);
    });

    const privacyPolicyCheckbox = PreferenceCenter_getPrivacyPolicyCheckbox(preferenceCenter);
    privacyPolicyCheckbox.addEventListener("change", () => {
        PreferenceCenter_hidePrivacyPolicyError(preferenceCenter);
    });

    updateSmsAvailability(preferenceCenter);

    appendPreferenceCenterPhoneNumberFormatMessage(preferenceCenter);

    const countrySelect = getPreferenceCenterCountrySelect(preferenceCenter);
    await initializeCountryOptionsWithMarketoOptions(countrySelect);

    // NOTE:
    // The country has not been set on the initial call above!
    // We need this to set the country after the Marketo country options are available.
    // We are also initializing the values before loading Marketo values, to avoid a FOUC.
    setPreferenceCenterOptionsFromBrowserUrl(preferenceCenter);
    whenPreferenceCenterCountrySelectChange(preferenceCenter);

    countrySelect.addEventListener("change", () => {
        whenPreferenceCenterCountrySelectChange(preferenceCenter);
    });
}
